// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AiUpdateContentRequestDto } from '../models';
// @ts-ignore
import type { AiUpdateContentResponseDto } from '../models';
/**
 * AiRestApi - axios parameter creator
 */
export const AiRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update text content
         * @param {AiUpdateContentRequestDto} aiUpdateContentRequestDto Request body for updating text content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContent: async (aiUpdateContentRequestDto: AiUpdateContentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiUpdateContentRequestDto' is not null or undefined
            assertParamExists('updateContent', 'aiUpdateContentRequestDto', aiUpdateContentRequestDto)
            const localVarPath = `/api/v1/ai/update-content`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiUpdateContentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiRestApi - functional programming interface
 */
export const AiRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AiRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update text content
         * @param {AiUpdateContentRequestDto} aiUpdateContentRequestDto Request body for updating text content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContent(aiUpdateContentRequestDto: AiUpdateContentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiUpdateContentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContent(aiUpdateContentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AiRestApi.updateContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AiRestApi - factory interface
 */
export const AiRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AiRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Update text content
         * @param {AiUpdateContentRequestDto} aiUpdateContentRequestDto Request body for updating text content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContent(aiUpdateContentRequestDto: AiUpdateContentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AiUpdateContentResponseDto> {
            return localVarFp.updateContent(aiUpdateContentRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AiRestApi - interface
 */
export interface AiRestApiInterface {
    /**
     * 
     * @summary Update text content
     * @param {AiUpdateContentRequestDto} aiUpdateContentRequestDto Request body for updating text content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContent(aiUpdateContentRequestDto: AiUpdateContentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AiUpdateContentResponseDto>;

}

/**
 * AiRestApi - object-oriented interface
 */
export class AiRestApi extends BaseAPI implements AiRestApiInterface {
    /**
     * 
     * @summary Update text content
     * @param {AiUpdateContentRequestDto} aiUpdateContentRequestDto Request body for updating text content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateContent(aiUpdateContentRequestDto: AiUpdateContentRequestDto, options?: RawAxiosRequestConfig) {
        return AiRestApiFp(this.configuration).updateContent(aiUpdateContentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

